import React from 'react';
import { Procedure } from 'types/procedure';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import StatusChip from 'components/data-grid/StatusChip';
import { procedureTableTemplate } from '../../template/procedureTableTemplate';

type ProcedureListTableProps = {
  procedures: Procedure[];
};

const ProcedureListTable: React.FC<ProcedureListTableProps> = ({ procedures }) => {
  return (
    <DataGridList
      template={procedureTableTemplate}
      rows={procedures}
      getRowId={row => row.id}
      renderCells={{
        formattedActive: row => <StatusChip active={Boolean(row.active)} label={row.formattedActive ?? ''} />,
      }}
      onRowClick={row => history.push(`/procedures/${row.id}`)}
      fileName="procedimentos"
      sheetName="Procedimentos"
    />
  );
};

export default ProcedureListTable;
